import React from "react";

const NewTeam = () => {
    return(
        <div>
            New Team
        </div>
    );
}

export default NewTeam;
